import { __read, __spread } from "tslib";
import { mergeDeep, ERROR_SYMBOL } from '@graphql-tools/utils';
import { OBJECT_SUBSCHEMA_SYMBOL, FIELD_SUBSCHEMA_MAP_SYMBOL } from '../symbols';
export function mergeProxiedResults(target) {
    var _a;
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    var results = [];
    var errors = [];
    sources.forEach(function (source) {
        if (source instanceof Error) {
            errors.push(source);
        }
        else {
            results.push(source);
            errors.push(source[ERROR_SYMBOL]);
        }
    });
    var fieldSubschemaMap = results.reduce(function (acc, source) {
        var subschema = source[OBJECT_SUBSCHEMA_SYMBOL];
        Object.keys(source).forEach(function (key) {
            acc[key] = subschema;
        });
        return acc;
    }, {});
    var result = results.reduce(mergeDeep, target);
    result[FIELD_SUBSCHEMA_MAP_SYMBOL] = target[FIELD_SUBSCHEMA_MAP_SYMBOL]
        ? Object.assign({}, target[FIELD_SUBSCHEMA_MAP_SYMBOL], fieldSubschemaMap)
        : fieldSubschemaMap;
    result[ERROR_SYMBOL] = (_a = target[ERROR_SYMBOL]).concat.apply(_a, __spread(errors));
    return result;
}
//# sourceMappingURL=mergeProxiedResults.js.map